module.exports = __webpack_public_path__ + "static/tegelwerk-1-14d1355f8f9741a4abcb22b7984aa532.jpg";